<template>
    <div>
        <app-form v-bind:parentObject="{
            data: this.formData,
            pageTitle: this.pageTitle,
            pageTitleValue: this.pageTitleValue,
        }" />
        <div v-if="isErr">
            <app-error v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr
            }" />
        </div>
    </div>
</template>

<script>
import AcknowledgementAcceptanceListingForm from '../../../components/settings/acknowledgement/Form_Parameter';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
    components: {
        'app-form': AcknowledgementAcceptanceListingForm,
        'app-error': ErrorDialog
    },

    data() {
        return {
            pageTitle: this.$t('acknowledgement.acknowledgementacceptancesummary'),
            pageTitleValue: '',

            formData: {
            },

            //dataItems: [],

            errMsg: '',
            isErr: false,
            isEdit: false
        }
    },

    methods: {
    }
}
</script>